export class FilterRealSeason {
    ctrl_page: number;
    ctrl_id: number;
    ctrl_startDate: string;
    ctrl_endDate: number;
    ctrl_description: string;

}